const ENTER_KEY_CODE = 13;
const UP_ARROW_CODE = 38;
const DOWN_ARROW_CODE = 40;

export class KeyPressEventService {
  static enterKeyPressed(keyPressEvent) {
    return keyPressEvent.keyCode === ENTER_KEY_CODE || keyPressEvent.key === 'Enter';
  }

  static transformEventToArrowPress(keyPressEvent) {
    const keyCode = keyPressEvent.keyCode || keyPressEvent.charCode || 0;
    if (keyCode === UP_ARROW_CODE) {
      return { isArrowKey: true, key: 'up', shiftKey: keyPressEvent.shiftKey };
    }
    if (keyCode === DOWN_ARROW_CODE) {
      return {
        isArrowKey: true,
        key: 'down',
        shiftKey: keyPressEvent.shiftKey,
      };
    }
    return { isArrowKey: false };
  }

  static getUpArrowEvent = () => {
    return {
      keyCode: UP_ARROW_CODE,
    };
  };

  static getDownArrowEvent = () => {
    return {
      keyCode: DOWN_ARROW_CODE,
    };
  };
}
